// eslint-disable-next-line max-classes-per-file
const queryString = require('query-string');
const q = require('queried');
const cookie = require('cookie-cutter');
const ext = require('deep-extend');
const { getUserCoords } = require('../utils');

const {
  Controller,
} = require('./core');

const {
  Filter,
} = require('./filter');

function isLeftButtonClick(e) {
  return e.button === 0;
}

/**
 * Get initial navigation filter state from current URL.
 *
 * @returns {{navigation: *}}
 */
function getInitialState() {
  const fields = [
    'order',
    'date',
    'only_free',
    'hide_online',
    'tickets',
  ];

  const query = queryString.parse(window.location.search);

  const reducer = (result, field) => {
    if (query[field]) {
      return ext(result, {
        [field]: [query[field]],
      });
    }

    return result;
  };

  const navigation = fields.reduce(reducer, {});

  return {
    navigation,
  };
}

class NavigationController extends Controller {
  constructor(...args) {
    super(...args);
    this.model.update((state) => ext(state, getInitialState()));
  }

  reset(key) {
    this.model.updateWithSync((state) => {
      if (state.navigation) {
        delete state.navigation[key];
      }

      return state;
    });
  }

  enable(key, value) {
    this.model.updateWithSync((state) => ext(state, {
      navigation: {
        [key]: [value],
      },
    }));
  }

  toggle(key, value) {
    this.model.updateWithSync((state) => {
      const values = (state.navigation && state.navigation[key]) || [];

      if (values.indexOf(value) == -1) {
        values.push(value);
      } else {
        values.splice(values.indexOf(value), 1);
      }

      return ext(state, {
        navigation: {
          [key]: values,
        },
      });
    });
  }

  toggleOne(key, value) {
    this.model.updateWithSync((state) => {
      const values = (state.navigation && state.navigation[key]) || [];

      if (values.length === 0) {
        values.push(value);
      } else if (values.indexOf(value) == -1) {
        values[0] = value;
      } else {
        this.reset(key);
      }

      return ext(state, {
        navigation: {
          [key]: values,
        },
      });
    });
  }

  order(key, value, isReversible) {
    if (value == 'proximity') {
      return getUserCoords().then((coords) => {
        if (coords) {
          cookie.set('coords', `${coords.longitude},${coords.latitude}`);
        }
        this.enable(key, value);
      });
    }

    const orderState = this.model.state.navigation.order;
    const currentValue = orderState && orderState[0];
    let newOrder;

    if (currentValue === value && isReversible) {
      newOrder = `-${value}`;
    } else {
      newOrder = value;
    }

    this.enable(key, newOrder);
  }
}

class NavigationView extends Filter {
  constructor(...args) {
    super(...args);
    this.events.bind('mousedown [data-mode="order"]', 'order');
    this.initCalendar();
  }

  initCalendar() {
    const reactDatePickerContainer = document.getElementById('react-date-picker');
    const that = this;
    const onSelect = (e) => {
      that.emit('enable', 'date', e.detail.date);
    };
    if (!reactDatePickerContainer) {
      return;
    }
    reactDatePickerContainer.addEventListener('select', onSelect);
  }

  order(e) {
    if (isLeftButtonClick(e)) {
      this.emitFor('order', e);
    }
  }

  emitFor(action, e) {
    const target = e.delegateTarget;
    const key = target.getAttribute('data-key');
    const value = target.getAttribute('data-value');
    const isReversible = target.hasAttribute('data-reversible');

    this.emit(action, key, value, isReversible);
    e.preventDefault();
  }

  updateCalendar(state) {
    const ev = new CustomEvent('feedModelUpdate', {
      bubbles: true,
      detail: { renderState: state },
    });
    document.dispatchEvent(ev);
  }

  render(state) {
    const data = state.navigation;
    this.renderNavbarItems(data);
    this.renderDefaultItems(data);
    this.renderCheckboxes(data);
    this.updateCalendar(data);
  }

  renderNavbarItems(data) {
    const selector = '.navbar-calendar-item, .navbar-item';

    q.all(selector, this.element).forEach((elem) => elem.classList.remove('active'));

    const keys = Object.keys(data);
    keys.forEach((key) => {
      const values = data[key] || [];

      values
        .map((value) => {
          // remove "-" symbol from the beginning
          // needed to highlight descending order widgets
          // should not affect other widgets
          const ascendingValue = value.replace(/^-/, '');
          return `[data-key="${key}"][data-value="${ascendingValue}"]`;
        })
        .map((sel) => q(sel, this.element))
        .filter((elem) => elem && !q('.checkbox', elem))
        .map((elem) => elem.closest(selector))
        .forEach((elem) => elem.classList.add('active'));
    });

    // render ordering items
    q.all('[data-mode="order"]', this.element).forEach((item) => {
      const sortOrder = q('.navbar-sortOrder', item);
      if (
        item.parentNode.classList.contains('active')
        && item.hasAttribute('data-reversible')
      ) {
        const value = data[item.getAttribute('data-key')];
        if (value[0][0] === '-') {
          sortOrder.textContent = '▼';
        } else {
          sortOrder.textContent = '▲';
        }
      } else {
        sortOrder.textContent = '';
      }
    });
  }

  renderDefaultItems(data) {
    const keys = Object.keys(data);
    const selector = '.navbar-calendar-item.defaut, .navbar-item.default';
    const elements = q.all(selector, this.element);
    elements.forEach((elem) => {
      const link = q('a[data-key]', elem);
      if (link) {
        const key = link.getAttribute('data-key');
        if (keys.indexOf(key) == -1) {
          elem.classList.add('active');
        }
      }
    });
  }

  renderCheckboxes(data) {
    const elements = q.all('[data-key] .checkbox', this.element);
    elements.forEach((elem) => {
      const container = elem.closest('[data-key]');
      if (container) {
        const key = container.getAttribute('data-key');
        const checked = data[key] && data[key].length;
        if (checked) {
          elem.classList.add('checked');
        } else {
          elem.classList.remove('checked');
        }
      }
    });
  }
}

module.exports = {
  NavigationController,
  NavigationView,
};
